import { Component, useCallback, useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import {
  checkCardIsSelected,
  goTo,
  isJsonParsable,
  returnCardInfo,
  setSelectedCard,
} from "../../utilities/common.utilities";
import { getUserCards } from "../../service/card.service";
import cardModel from "../../static/card-model";
import "./toolbar.css";
import { useConnectivity } from "../../context/connectivityContext";
import {
  getUserProfile,
  getUserProfileWithoutInterceptor,
} from "../../service/profile.service";

export default function ToolbarComponent() {
  const location = useLocation();
  const [groupName, setGroupName] = useState<string>("");
  const [storeName, setStoreName] = useState<string>("");
  const { isOnline } = useConnectivity();

  const previousPath = () => {
    localStorage.setItem("previousPath", location.pathname )
    // console.log(location.pathname)
  }

  useEffect(() => {
    // Recupero i dati del profilo nella toolbar in modo che se non c'è connessione ad internet, quando si clicca sull'icona
    // del menù i dati sono presenti
    getUserProfileWithoutInterceptor();

    if (checkCardIsSelected()) {
      returnCardInfo().then((card) => {
        setGroupName(card.groupName);
        setStoreName(card.mainStoreName);
      });
    } else {
      getUserCards().then((cardData: cardModel) => {
        if (cardData?.cards?.length > 0) {
          const card = cardData.cards[0].cardNumber;
          const groupName = cardData.cards[0].groupName;
          const storeName = cardData.cards[0].mainStoreName;

          setSelectedCard(card);
          setGroupName(groupName);
          setStoreName(storeName);
        } else {
          // no card linked
        }
      });
    }

    //console.log("url changed --> " + location.pathname)
  }, [location, isOnline]);

  return (
    <div className={"new-header " + (isOnline ? "" : "new-header-offline")}>
      {/* <div className="flex overflow-hidden mt-1">
                    <div className="flex-none flex align-items-center justify-content-center ml-2">
                        <div className="flex flex-column">
                            <div className="flex align-items-center justify-content-center">
                            <Link to="/home">
                                { location.pathname !== '/home' && location.pathname !== '/' ?
                                  <i className="pi pi-arrow-left inline-flex justify-content-center align-items-center text-white" style={{ fontSize: '2rem' }}></i>
                                : <div></div>

                                }
                                
                            </Link>
                            </div>
                        </div>
                    </div>
                    <div className="flex-grow-1 flex-column flex align-items-center justify-content-center "> 
            
                    <div 
                        className='flex-column text-white flex align-items-center text-center groupName'
                        style={{ fontWeight: 'bold' }}>
                        {groupName}
                    </div>    
                    </div>
                    <div className="flex-none flex align-items-center justify-content-end mr-2">
                        <div className="flex flex-column" onClick={() => goTo('/menu')}>
                            <div className="flex align-items-center justify-content-center text-white">
                                        <i className="pi pi-bars" id="menuButton"  style={{ fontSize: '3rem', color: 'white' }}></i>         
                                </div>
                                <div className="flex align-items-center justify-content-center font-bold text-white">
                                    <label style={{ fontSize: '8px', fontWeight: 'bold' }} htmlFor="menuButton">MENU</label>    
                                </div>
                        </div>
                    </div>
                </div> */}

      <div className="grid grid-nogutter flex align-items-center mt-1 toolbar-style">
        <div className="col-2">
          <div className="flex-none flex align-items-center justify-content-center ml-2">
            {location.pathname !== "/home" && location.pathname !== "/" ? (
              <div>

                <div className="flex flex-column">
                  <div className="flex align-items-center justify-content-center">
                    <Link to={"/home"} className=" link-decoration ">
                      <div
                        className="flex flex-column"
                        style={{ cursor: "pointer" }}
                      >
                        <div className="flex align-items-center justify-content-center text-white">
                          <i className="pi pi-arrow-left icons-header"></i>
                        </div>
                        <div
                          className="flex align-items-center justify-content-center font-bold text-white"
                          style={{ position: "relative", top: "-5px" }}
                        >
                          <label
                            style={{ fontSize: "8px", fontWeight: "bold" }}
                            htmlFor="backButton"
                          >
                            INDIETRO
                          </label>
                        </div>
                      </div>
                    </Link>
                  </div>
                </div>
              </div>
            ) : (
              <div className="flex-column justify-content-center align-items-center">
                <div>
                  <img
                    src="new_icons/MySalusAPP_PITTOGRAMMA_WHITE.svg"
                    alt=""
                    className=" flex justify-content-center align-items-center logo-toolbar "
                  />
                </div>
                {/* <div className=" flex justify-content-center align-items-center ">
                  {process.env.REACT_APP_SUFFIX_TITLE_HEADER &&
                  storeName !== groupName ? (
                    <div
                      className="  "
                      style={{
                        fontWeight: "normal",
                        fontSize: "10px",
                      }}
                    >
                      <div className=" align-items-center  title-login">
                        {process.env.REACT_APP_SUFFIX_TITLE_HEADER}
                      </div>
                    </div>
                  ) : (
                    <></>
                  )}
                </div> */}
              </div>
            )}
          </div>
        </div>
        <div className="col-8">
          <div className="flex-grow-1 flex-column flex align-items-center justify-content-center relative">
            <div
              className="flex-column text-white flex align-items-center text-center storeName"
              style={{ fontWeight: "bold", position: "relative" }}
            >
              {storeName}
            </div>
            {storeName !== groupName ? (
              <div className="groupName text-white font-italic mb-1">
                {groupName}
              </div>
            ) : (
              <></>
            )}

            {process.env.REACT_APP_SUFFIX_TITLE_HEADER ? (
              <div
                className="flex justify-content-end "
                style={{
                  fontWeight: "normal",
                  // bottom: "-0.4rem",
                  // right: "0.5rem",
                  fontSize: "10px",
                  position: "fixed",
                  marginRight: "-220px",
                  backgroundColor: "black",
                  padding: "1px 18px 3px",
                  borderRadius: "9px",
                  top: "58px"
                }}
              >
                <div className="flex align-items-center justify-content-end title-login">
                  {process.env.REACT_APP_SUFFIX_TITLE_HEADER}
                </div>
              </div>
            ) : (
              <></>
            )}
          </div>
        </div>
        <div className="col-2">
          <div className="flex-none flex align-items-center justify-content-end mr-2">
            <div
              className="flex flex-column"
              style={{ cursor: "pointer" }}
              onClick={() => {goTo("/menu"); previousPath()} }
            >
              <div className="flex align-items-center justify-content-center text-white">
                <i className="pi pi-bars icons-header" id="menuButton"></i>
              </div>
              <div
                className="flex align-items-center justify-content-center font-bold text-white"
                style={{ position: "relative", top: "-5px" }}
              >
                <label
                  style={{ fontSize: "8px", fontWeight: "bold" }}
                  htmlFor="menuButton"
                >
                  MENU
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
